import {
    BreadcrumbItems,
    BreadcrumbRouteResolver,
    LinkBreadcrumbItems,
    ResourceBreadcrumbItems
} from "@recursyve/ngx-panko";
import * as inflection from "inflection";

export class NerriBreadcrumbRouteResolver extends BreadcrumbRouteResolver {
    public getItemLink(currentItem: BreadcrumbItems | null): any[] {
        if (!currentItem) {
            return ["/dashboard"];
        }

        const path: any[] = ["/dashboard"];
        if ((currentItem as LinkBreadcrumbItems).link) {
            const item = currentItem as LinkBreadcrumbItems;
            if (Array.isArray(item.link)) {
                path.push(...item.link);
            } else {
                path.push(item.link);
            }
        } else {
            const item = currentItem as ResourceBreadcrumbItems;
            if (item.resourceName) {
                path.push(inflection.singularize(inflection.dasherize(item.resourceName)));
            }
            if (item.resourceId) {
                path.push(item.resourceId);
            }
        }

        return path;
    }
}
